<div *ngIf="reviewFormIsValid" [class.bg-modal--open]="this.modalIsOpen" class="bg-modal">

  <ng-container *ngIf="!this.dashboardError">

    <!-- SELEZIONA UTENTE -->
    <div [class.modal-contents--registration]="this.formValue==='registrati' && this.optionChangeForm.controls.selectedOption.value==='privato'" class="modal-contents">
      <div class="modal-contents__top py-3 px-4">
        <div *ngIf="this.formValue!=='recuperaPassword'" class="fw-normal">{{this.formValue==='accedi' ? 'Accedi' : 'Registrati'}}</div>
        <div *ngIf="this.formValue==='recuperaPassword'" class="fw-normal">Recupera Password</div>
        <div (click)="this.closeModal()" class="close">+</div>
      </div>

      <ng-container *ngIf="this.formValue==='accedi'">
        <form [formGroup]="this.optionChangeForm" class="col-12 optionChangeForm d-flex align-items-center justify-content-start px-4 py-3">
  
          <div class="d-flex align-items-center pe-3 cursor-pointer optionChangeForm_item selectedOption">
            <input formControlName="selectedOption" type="radio" name="selectedOption" id="privato" value="privato">
            <label class="form-check-label fw-400 ms-2 mb-0 cursor-pointer" for="privato">
              Privato
            </label>
          </div>

          <div class="d-flex align-items-center cursor-pointer optionChangeForm_item px-3 selectedOption">
            <input formControlName="selectedOption" type="radio" name="selectedOption" id="professionista" value="immobiliare">
            <label class="form-check-label fw-400 cursor-pointer ms-2 mb-0 text-left" for="professionista">
              Professionista
            </label>
          </div>

          <!-- <div class="d-flex align-items-center cursor-pointer optionChangeForm_item ps-3">
            <input formControlName="selectedOption" type="radio" name="selectedOption" id="consulente" value="consulente">
            <label class="form-check-label fw-400 cursor-pointer ms-2 mb-0 text-left" for="consulente">
              Consulente del credito
            </label>
          </div> -->

        </form>
      </ng-container>

      <!-- REVIEW PAGE -->
      <ng-container *ngIf="this.formValue===''">
        <div class="registrationCont mx-4 my-3">
          <h6 class="mb-1">Vuoi collegare il tuo account <span class="colorPrimary">Cercacasa.it</span> alla recensione?
          </h6>
          <div class="registrationCont__item d-flex py-3">
            <p class="mt-0 mb-0 cursor-pointer">Sei già registrato a <span class="colorPrimary fw-normal">Cercacasa.it
                ?</span></p>
            <button (click)="handleAccess()" class="ms-5">Accedi</button>
          </div>
    
          <div class="registrationCont__item d-flex py-3">
            <p class="cursor-pointer mb-0">Mi voglio registrare a <span class="colorPrimary fw-normal">Cercacasa.it</span>
            </p>
            <button (click)="handleRegistration()" class="ms-5">Registrati</button>
          </div>
    
          <div class="registrationCont__item pt-3">
            <p class="mb-0">oppure</p>
            <p (click)="handleWithoutRegistration()" class=" mt-2 colorPrimary cursor-pointer fw-normal">Procedi senza
              registrazione</p>
          </div>
    
        </div>
      </ng-container>

      <!-- FORM ACCEDI -->
      <form *ngIf="this.formValue==='accedi' && this.optionChangeForm.controls.selectedOption.value==='privato'" [formGroup]="this.signInForm" (ngSubmit)="this.signInSubmit()" class="formBorder px-3 pb-3" autocomplete="on">
        <!-- <hr class="mb-4 my-0"> -->
        <div class="col-lg-12 px-0 pt-4">
          <input class="mb-1" [ngClass]="{ 'redBorder': log.email.invalid && log.email.touched }"
            formControlName="email" type="email" id="email" placeholder="Indirizzo Email">
        </div>
        <div class="col-lg-12 px-0 passwordField">
          <input [ngClass]="{ 'redBorder': log.password.invalid && log.password.touched }" formControlName="password"
            type="{{passwordType}}" id="passwordLogin" placeholder="Password" autocomplete="true">
          <i class="colorPrimary passwordIcon cursor-pointer far" [class.icon-eye]="this.isPassword"
            [class.icon-eye-slash]="!this.isPassword" (click)="changePasswordType()"></i>
        </div>

        <small [ngClass]="{'d-none': log.email.valid || log.email.untouched}" class="text-danger">Inserisci un indirizzo
          email valido</small>
        <small [ngClass]="{'d-none': log.password.valid || log.password.untouched}"
          class="text-danger smallPassword">Inserire la password corretta</small>

        <p (click)="handleForgottenPassword()"
          class="recuperaPassord text-primary text-start text-password m-0 fw-normal cursor-pointer">Passsword
          Dimenticata?</p>
        <p *ngIf="submitted && error" class="alert alert-danger m-0 mt-2">{{error}}</p>
        <button [disabled]="!signInForm.valid || loading" class="btn mt-3" type="submit">
          Accedi
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
        </button>
        <p class="p-0 pt-4 m-0">Non sei un utente registrato?<span (click)="handleRegistration()"
            class="text-primary fw-normal ps-1 cursor-pointer">Registrati è gratis</span></p>
      </form>

      <!-- FORM REGISTRATI -->
      <form *ngIf="this.formValue==='registrati' && this.optionChangeForm.controls.selectedOption.value==='privato'" [formGroup]="this.signUpForm" (ngSubmit)="this.signUpSubmit()" class="px-3 pb-1 pt-3">
        
        <div class="row">
          <ng-container *ngIf="this.reviewFormUserData">
            <div class="col-lg-6 col-md-6 pr-lg-1 pr-md-1">
              <input class="mb-1" [ngClass]="{ 'redBorder': sign.first_name?.invalid && sign.first_name?.touched }"
                formControlName="first_name" type="text" placeholder="*Nome" [(ngModel)]="this.reviewFormUserData.name">
            </div>
            <div class="col-lg-6 col-md-6 pl-lg-1 pl-md-1">
              <input class="mb-1" [ngClass]="{ 'redBorder': sign.last_name?.invalid && sign.last_name?.touched }"
                formControlName="last_name" type="text" placeholder="*Cognome"
                [(ngModel)]="this.reviewFormUserData.surname">
            </div>
            <div class="col-lg-12">
              <input class="mb-1" (keypress)="onlyNumberAllowed($event)"
                [ngClass]="{ 'redBorder': sign.phone_number.invalid }" formControlName="phone_number" type="tel"
                placeholder="Numero di telefono" [(ngModel)]="this.reviewFormUserData.phone">
            </div>
            <div class="col-lg-12">
              <input class="mb-1" [ngClass]="{ 'redBorder': sign.email.invalid && sign.email.touched }"
                formControlName="email" type="email" placeholder="*Indirizzo email"
                [(ngModel)]="this.reviewFormUserData.email">
            </div>
          </ng-container>
          <ng-container *ngIf="!this.reviewFormUserData">
            <div class="col-lg-6 col-md-6 pr-lg-1 pr-md-1">
              <input class="mb-1" [ngClass]="{ 'redBorder': sign.first_name?.invalid && sign.first_name?.touched }"
                formControlName="first_name" type="text" placeholder="*Nome">
            </div>
            <div class="col-lg-6 col-md-6 pl-lg-1 pl-md-1">
              <input class="mb-1" [ngClass]="{ 'redBorder': sign.last_name?.invalid && sign.last_name?.touched }"
                formControlName="last_name" type="text" placeholder="*Cognome">
            </div>
            <div class="col-lg-12">
              <input class="mb-1" (keypress)="onlyNumberAllowed($event)"
                [ngClass]="{ 'redBorder': sign.phone_number.invalid }" formControlName="phone_number" type="tel"
                placeholder="*Numero di telefono">
            </div>
            <div class="col-lg-12">
              <input class="mb-1" [ngClass]="{ 'redBorder': sign.email.invalid && sign.email.touched }"
                formControlName="email" type="email" placeholder="*Indirizzo email">
            </div>
          </ng-container>
          <div class="col-lg-12 passwordField">
            <input class="mb-1" [ngClass]="{ 'redBorder': sign.password.invalid && sign.password.touched}"
              formControlName="password" type="{{passwordType}}" placeholder="*Password" autocomplete="on">
            <i class="colorPrimary passwordIcon cursor-pointer far" [class.icon-eye]="this.isPassword"
              [class.icon-eye-slash]="!this.isPassword" (click)="changePasswordType()"></i>
          </div>
          <div class="col-lg-12 passwordField">
            <input class="mb-1" [ngClass]="{ 'redBorder': sign.confirmPassword.errors && sign.confirmPassword.touched }"
              formControlName="confirmPassword" type="{{passwordConfirmType}}" placeholder="*Conferma password" autocomplete="on">
            <i class="passwordIcon colorPrimary cursor-pointer far" [class.icon-eye]="this.isPasswordConfirm"
              [class.icon-eye-slash]="!this.isPasswordConfirm" (click)="changePasswordConfirmType()"></i>
          </div>
          <div class="col-lg-12 moreInfoCont py-2">
            <p class="mb-0 colorPrimary fw-normal">Per meglio trovare la tua casa ideale aiutaci inserendo questi
              ulteriori dati.</p>
          </div>
          <div class="col-lg-6 col-md-6 pe-lg-1">
            <select formControlName="state" type="text" class="form-control" name="provincia">
              <option value="" disabled selected>Seleziona una provincia</option>
              <option *ngFor="let province of this.main?.provinceComuni" [value]="province?.name">{{province?.name}}
              </option>
            </select>
          </div>
          <div class="col-lg-6 col-md-6 ps-lg-1">
            <select formControlName="city" type="text" class="form-control" placeholder="Comune di residenza"
              name="comune">
              <option value="" disabled selected>Seleziona un comune</option>
              <option *ngFor="let comune of this.getCityList()" [value]="comune">{{comune}}</option>
            </select>
          </div>

          <div class="col-lg-12">
            <input type="date" class="date" formControlName="birthday" placeholder="Data di Nascita">
          </div>

          <div class="col-lg-12">
            <div class="selectSex py-1 my-1 px-3 d-flex">
              <p class="mb-0">Sesso: </p>
              <div class="selectSex__cont d-flex">
                <div class="form-group mb-0 d-flex">
                  <input formControlName="sex" class="cursor-pointer" value="uomo" type="radio" id="uomo" name="sex">
                  <label class="mb-0 ms-2 me-2 fw-normal" for="uomo">Uomo</label>
                </div>
                <div class="form-group mb-0 d-flex">
                  <input formControlName="sex" class="cursor-pointer" value="donna" type="radio" id="donna" name="sex">
                  <label class="mb-0 ms-2 fw-normal" for="donna">Donna</label>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-lg-12 form-group--check d-flex mt-3">
            <input type="checkbox" class="me-3 cursor-pointer" formControlName="consent_newsletter"
              id="consent_newsletter">
            <label class="mb-0 fw-normal cursor-pointer" for="consent_newsletter">Desidero ricevere comunicazioni
              informative e promozionali.</label>
          </div>

          <div class="col-lg-12 form-group--check d-flex">
            <input type="checkbox" class="me-3 cursor-pointer" formControlName="consent_communications"
              id="consent_communications">
            <label class="mb-0 fw-normal cursor-pointer" for="consent_communications">Desidero ricevere la
              Newsletter.</label>
          </div>

          <div class="col-lg-12 form-group--check d-flex">
            <input type="checkbox" class="me-3 cursor-pointer" formControlName="accepts_terms_and_conditions"
              id="accepts_terms_and_conditions">
            <label class="mb-0 fw-normal cursor-pointer" for="accepts_terms_and_conditions">Ho letto e acconsento le <a
                href="javascript:void(0);" [routerLink]="['/condizioni-uso']" class="text-primary fw-normal">Condizioni
                Generali</a> e <a href="javascript:void(0);" [routerLink]="['/privacy-policy']"
                class="text-primary fw-normal">l'Informativa sulla Privacy</a>.</label>
          </div>
        </div>

        <small [ngClass]="{'d-none': sign.last_name?.valid || sign.last_name?.untouched}" class="text-danger"> Cognome è
          un campo obbligatorio.</small>
        <small [ngClass]="{'d-none': sign.email.valid || sign.email.untouched}" class="text-danger"> Inserire un email
          valida.</small>
        <small [ngClass]="{'d-none': sign.phone_number.valid}" class="text-danger">Il numero di telefono deve avere
          almeno 8 caratteri.</small>
        <small *ngIf="!this.onlyPhoneNumber" class="text-danger me-1"> Il numero di telefono non può contenere
          lettere.</small>
        <small [ngClass]="{'d-none': sign.password.valid || sign.password.untouched}" class="text-danger">Password è un
          campo obbligatorio.</small>
        <small [ngClass]="{'d-none': sign.confirmPassword.valid || sign.confirmPassword.untouched}"
          class="text-danger">Inserire Password di conferma.</small>
        <small [ngClass]="{'d-none': sign.first_name?.valid || sign.first_name?.untouched}" class="text-danger"> Nome è
          un campo obbligatorio.</small>
        <small *ngIf="sign.confirmPassword.hasError('passwordMismatch')" class="text-danger"> Le password inserite non
          corrispondono.</small>
        <small
          *ngIf="sign.accepts_terms_and_conditions?.invalid && sign.last_name?.valid && sign.email.valid && sign.password.valid && sign.confirmPassword.valid"
          class="text-danger">
          Condizioni generali è un campo obbligatorio.
        </small>

        <button [disabled]="!signUpForm.valid || loading" class="btn mt-3" type="submit">
          Registrati
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
        </button>
        <p class="p-0 py-3 m-0">Sei un utente registrato? <span (click)="handleAccess()"
            class="text-primary fw-normal ps-1 cursor-pointer">Accedi</span></p>
      </form>

      <!-- RECUPERA PASSWORD -->
      <form *ngIf="this.formValue==='recuperaPassword'" [formGroup]="this.lostPasswordForm" (ngSubmit)="this.lostPasswordSubmit()" class="px-3 pt-3 pb-3 recuperaPassword">
        <p class="text-start">Inserisci l'indirizzo e-mail che utilizzi per accedere al sito.</p>
        <input class="mb-1" [ngClass]="{ 'redBorder': recPassword.email.invalid && recPassword.email.touched }"
          formControlName="email" type="email" placeholder="Indirizzo email">
        <small [ngClass]="{'d-none': recPassword.email.valid || recPassword.email.untouched}"
          class="text-danger">Inserisci il tuo indirizzo email</small>
        <button [disabled]="!lostPasswordForm.valid" class="btn mt-3" type="submit">
          Recupera Password
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
        </button>
      </form>

      <!-- PROFESSIONISTA IMMOBILIARE -->
      <ng-container *ngIf="this.optionChangeForm.controls.selectedOption.value==='immobiliare' && this.formValue !== ''">
        <div class="registrationCont formBorder px-3 mb-4">
          <h6 class="mb-1 pt-3">Accedi o Registrati  per entrare su <span class="colorPrimary">Cercacasa.it</span></h6>
          <div class="registrationCont__item d-flex py-3">
            <p class="mt-0 mb-0 cursor-pointer">Sei già registrato a <span class="colorPrimary fw-normal">Cercacasa.it?</span></p>
            <button (click)="this.main?.linkBlank(this.main?.dashboardLink+'/login')" class="ms-5">Accedi</button>
          </div>
    
          <div class="registrationCont__item d-flex py-3">
            <p class="cursor-pointer mb-0">Registrati come professionista a <span class="colorPrimary fw-normal">Cercacasa.it</span></p>
            <button (click)="this.main?.linkBlank(this.main?.dashboardLink+'/registrazione')"  class="ms-5">Registrati</button>
          </div>
        </div>
      </ng-container>

      <!-- popup button in ACCEDI -->
      <ng-container *ngIf="isReviewPage && this.formValue !== ''">
        <div (click)="this.openModal()" (click)="handleWithoutRegistration()"
          class="modal-contents__bottom py-3 cursor-pointer fw-normal">
          <p class="colorPrimary p-0 m-0">Procedi senza registrazione.</p>
        </div>
      </ng-container>

      <ng-container *ngIf="this.formValue==='recuperaPassword'"> 
        <div class="modal-contents__bottom py-3">
          <p class="p-0 m-0">Sei un' utente già registrato?<span
              class="text-primary fw-normal ps-1 cursor-pointer"
              (click)="handleAccess()">Accedi</span>
            </p>
        </div>
      </ng-container>

    </div>
  </ng-container>

  <ng-container *ngIf="this.dashboardError">
    <div *ngIf="this.formValue==='accedi'" class="modal-contents">
        <div class="modal-contents__top py-2 px-4">
          <div class="fw-normal">Utenza dashboard</div>
          <div (click)="this.closeModal()" class="close">+</div>
        </div>
        <p class="mt-2">L'utenza risulta collegata ad un profilo da Professionista immobiliare. </p>
        <p>Registrati o loggati con un'utenza cercacasa.it o vai su <a [href]="this.main?.dashboardLink" target="_blank">dashboard</a></p>
        <a [href]="this.main?.dashboardLink" class="btn btn-primary m-2">Vai su dashboard</a>
        <button class="btn btn-light m-2" (click)="this.signInForm.reset(); this.dashboardError=false">Continua su cercacasa.it</button>
    </div>
  </ng-container>
</div>
